// Homepage sales agent on the shared web-chat client.

import { streamWebChat } from "../../chat/client";
import type { ChatPart, ChatWidgetPart } from "../../chat/types";
import type { IntakeEmbed } from "../embeds/IntakeForm";

export type { ChatPart as SalesTurn };
export type { IntakeEmbed };

export type SalesChatResult =
  | {
      ok: true;
      reply: string;
      embed?: IntakeEmbed;
      widgets?: ChatWidgetPart[];
    }
  | { ok: false };

export async function postSalesChat(input: {
  messages: ChatPart[];
  onDelta?: (text: string) => void;
}): Promise<SalesChatResult> {
  const result = await streamWebChat(input);
  if (!result.ok) return result;
  const embed = result.embed?.kind === "intake_form" ? result.embed : undefined;
  return {
    ok: true,
    reply: result.reply,
    ...(embed ? { embed: embed as IntakeEmbed } : {}),
    ...(result.widgets?.length ? { widgets: result.widgets } : {}),
  };
}
